import './style.css'
import './tw-play.css'

import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import { registerComponents } from "./components/atomic";
import "./utils/route-paths";
import "./utils/global-helpers";

import { createApp } from 'vue'
import Cookies from "js-cookie"
import App from './App.vue'
import router from './router/index'
import { createPinia } from 'pinia'
import { i18n } from './i18n'
import VueClickAway from "vue3-click-away";
import { vMaska } from "maska/vue";
import { vAutoContrast } from './directives/auto-contrast';
import { ClickOutside } from './directives/click-outside';


const app = createApp(App)

registerComponents(app)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(VueClickAway)
app.directive("maska", vMaska);
app.directive('auto-contrast', vAutoContrast)
app.directive('click-outside', ClickOutside)

play.auth.url(import.meta.env.VUE_APP_API_HOST)
play.auth.token(Cookies.get("auth_greennCourse"))

router.isReady().then(() => {
  app.mount('#app')
})

import("./main-lazy").then(({ registerPlugins }) => {
  registerPlugins(app)
})

const loader = document.querySelector('#loader') as HTMLElement | null
const body = document.body
if (loader) loader.style.display = 'none'
body.style.visibility = 'visible'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { play } from '@voomp/play-back'
NProgress.configure({ showSpinner: false })

import { useLayoutStore } from '@/store/layout.store'

router.beforeEach((to, from, next) => {
  NProgress.start()
  const layoutStore = useLayoutStore()
  const isMobileOrTablet = layoutStore.getLayout?.breakpoint <= 2
  if (to.meta.sidebarCollapsable || isMobileOrTablet) {
    layoutStore.actionHideSidebar()
  } else {
    layoutStore.actionShowSidebar()
  }
  next()
})

router.afterEach((_to) => {
  NProgress.done()
})

router.beforeResolve((to, from, next) => {
  const layoutStore = useLayoutStore()
  layoutStore.actionSetSidebarLocked(to.meta?.sidebarCollapsable as boolean ?? false);
  next()
})

